import { IForm } from 'core-components/classes/models/IForm'

// export const FillFormByStructure = (
//    data: IForm,
//    structure: string[]
// ): IForm => {
//    const form: IForm = {}
//    structure.forEach(value => (form[value] = data[value]))
//    return form
// }

// export const FillModifiedField = (data: IForm, newModified: string) => {
//   const basicModified = (data['ModifiedValues'] && data['ModifiedValues'].split(',')) || []
//   let modifiedArray: string[] = basicModified.concat((newModified && newModified.split(',')) || [])
//   modifiedArray = modifiedArray.map((value) => value.trim())
//   modifiedArray = modifiedArray.filter((value, index, self) => self.indexOf(value) === index)
//   data['ModifiedValues'] = modifiedArray.toString()
// }

export class DataModel {
  rawData: IForm
  rawDataFirstVersion: IForm
  version: number = 0
  modified: string[] = []

  constructor(data: IForm) {
    this.rawData = { ...data }
    this.rawDataFirstVersion = { ...data }
  }

  clone() {
    return new DataModel(this.rawData)
  }

  get(field: string, orValue?: any): any {
    const currentModified: string[] =
      (~field.indexOf('Legal') || field === 'CompanyEnglishName'
        ? this.rawData['LegalModifiedValuesExt']
        : this.rawData['ModifiedValues'] && this.rawData['ModifiedValues'].split(',')) || []

    return (
      (currentModified.indexOf(field) > -1
        ? this.rawData[`${field}Ext`]
        : this.rawData[`${field}Ext`] || this.rawData[field]) || orValue
    )
  }

  set(field: string, value: unknown) {
    if (this.rawData.hasOwnProperty(`${field}Ext`)) {
      if (~field.indexOf('Legal') || field === 'CompanyEnglishName') {
        const legalMVE = this.rawData['LegalModifiedValuesExt']
        const currentModified: string[] = legalMVE
          ? typeof legalMVE === 'string'
            ? JSON.parse(legalMVE)
            : legalMVE.slice()
          : []
        const index = currentModified.indexOf(field)

        if (this.rawData[field] === value) {
          this.rawData[`${field}Ext`] = undefined
          if (index > -1) {
            currentModified.splice(index, 1)
          }
        } else {
          this.rawData[`${field}Ext`] = value
          if (index === -1) {
            currentModified.push(field)
          }
        }
        this.rawData['LegalModifiedValuesExt'] =
          typeof legalMVE === 'string' ? JSON.stringify(currentModified) : currentModified
      } else {
        const currentModified: string[] =
          (this.rawData['ModifiedValues'] && this.rawData['ModifiedValues'].split(',')) || []
        const index = currentModified.indexOf(field)

        if (this.rawData[field] === value) {
          this.rawData[`${field}Ext`] = undefined
          if (index > -1) {
            currentModified.splice(index, 1)
          }
        } else {
          this.rawData[`${field}Ext`] = value
          if (index === -1) {
            currentModified.push(field)
          }
        }
        this.rawData['ModifiedValues'] = currentModified.toString()
      }
    } else {
      this.rawData[field] = value
    }
    const indexModifiedField = this.modified.indexOf(field)
    if (
      this.rawData[field] !== this.rawDataFirstVersion[field] ||
      this.rawData[`${field}Ext`] !== this.rawDataFirstVersion[`${field}Ext`]
    ) {
      if (indexModifiedField === -1) {
        this.modified.push(field)
      }
    } else if (indexModifiedField > -1) {
      this.modified.splice(indexModifiedField, 1)
    }
    this.version++
  }

  isModified(field: string): boolean {
    return this.modified.indexOf(field) > -1
  }

  isEmpty(): boolean {
    return !Object.keys(this.rawData).length
  }
}
